import { render } from "./DeleteAssociationComponent.vue?vue&type=template&id=51547763"
import script from "./DeleteAssociationComponent.vue?vue&type=script&lang=js"
export * from "./DeleteAssociationComponent.vue?vue&type=script&lang=js"

import "./DeleteAssociationComponent.vue?vue&type=style&index=0&id=51547763&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__